import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { COMPONENTS } from '../../../../routers/constants'
import { LinkComponent } from '../../../common/html/LinkComponent'
import { TitleComponent } from '../../../common/html/TitleComponent'

export const TitleContent = () => {
  return (
    <>
      <div className="dFlex justifyContentBetween alignItemsCenter">
        <TitleComponent title="dashboard.currentPlan.package" />
        <div className="dFlex" style={{ gap: 12 }}>
          <LinkComponent
            href={`${COMPONENTS.userManagement.components.subscriptionPayment.route}?buyNow=true`}
          >
            <Element style={{ color: '#2C73E8' }}>
              <Translate value="dashboard.currentPlan.purchaseMore" />
            </Element>
          </LinkComponent>
          <LinkComponent
            href={
              COMPONENTS.userManagement.components.subscriptionPayment.route
            }
          >
            <Element style={{ color: '#2C73E8' }}>
              <Translate value="dashboard.latestReport.viewAll" />
            </Element>
          </LinkComponent>
        </div>
      </div>
    </>
  )
}
